import type { FileStoreService } from '@/services/abstract/poc/FileStoreService';
import type { HeliaNode } from '@/types/poc/helia';
import { normalizeCid } from '@/services/poc/cidUtils';

const KEY_BLOB_MIME_TYPE = 'application/json';

/**
 * Stores one serialized recipient key blob in local Helia and returns its
 * normalized CID. Shared by upload (`addFileToHeliaThunk`), facilitation
 * (`facilitateFileKeysThunk`), and change-password rotation — the blob is
 * written with `FileEncryptionService.serializeRecipientKeyBlob` and read back
 * with `parseRecipientKeyBlob` on the download path; that round-trip is the
 * contract, so all three writers must store blobs the same way.
 */
export async function storeRecipientKeyBlob(
  helia: HeliaNode,
  fileStoreService: FileStoreService,
  fileName: string,
  serializedBlob: string | Uint8Array<ArrayBuffer>
): Promise<string> {
  const blobFile = new File([serializedBlob], fileName, { type: KEY_BLOB_MIME_TYPE });
  const addResult = await fileStoreService.addFile(helia, blobFile);
  return normalizeCid(addResult.cid);
}
